import type { TimelineItemProps } from "./types";

import { BotIcon } from "../bot-icon";
import { useTimelineItem } from "./hooks";
import { MessageContentSimplified } from "./MessageContentSimplified";
import { Separator } from "./Separator";
import { TimelineItemWrapperSimplified } from "./TimelineItemWrapperSimplified";

export function TimelineItemSimplified({
    isLoading,
    isLastBotMessage,
    isLastProactiveMessage,
    message,
    type,
    logger,
    scrollRef,
    metadata,
    children,
    gaiaPayloadProps,
    smartOfferActions,
    isSaleSuccessOrDeclined = false,
}: TimelineItemProps) {
    const { config, overflowRef, messageIntersectionRef, quickActionGroupProps, isQuickActionsVisible } =
        useTimelineItem({
            type,
            message,
            isLoading,
            isLastBotMessage,
            isLastProactiveMessage,
            scrollRef,
            smartOfferActions,
            isSaleSuccessOrDeclined,
            logger,
            gaiaPayloadProps,
        });

    if (type === "Separator") {
        return (
            <TimelineItemWrapperSimplified alignsLeft={false}>
                <BotIcon isBotListening={false} isHidden={true} isLoading={false} />
                <Separator label={message?.text} />
            </TimelineItemWrapperSimplified>
        );
    }

    if (isLoading || !message) {
        return (
            <TimelineItemWrapperSimplified alignsLeft={config.alignsLeft}>
                <BotIcon isBotListening={false} isHidden={false} isLoading={isLoading} />
            </TimelineItemWrapperSimplified>
        );
    }

    return (
        <TimelineItemWrapperSimplified alignsLeft={config.alignsLeft}>
            <BotIcon isBotListening={config.isBotListening} isHidden={!isLastBotMessage} isLoading={false} />
            <MessageContentSimplified
                type={type}
                config={config}
                metadata={metadata}
                isLastProactiveMessage={isLastProactiveMessage}
                overflowRef={overflowRef}
                messageIntersectionRef={messageIntersectionRef}
                tag={message?.tag}
                message={message}
                quickActionGroupProps={quickActionGroupProps}
                isQuickActionsVisible={isQuickActionsVisible}
            >
                {children}
            </MessageContentSimplified>
        </TimelineItemWrapperSimplified>
    );
}
